import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";

// Компонент для захищених маршрутів
const ProtectedRoute = ({ requiredPermission }) => {
  const { isAllowed } = useAuth();

  // Якщо користувач не має дозволу, перенаправляємо його на головну сторінку
  if (!isAllowed(requiredPermission)) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
